/*
 * Copyright (c) 2023
 *
 * The source code and all documents related to the source code ("Material") are owned by
 * Frictionless Systems, LLC.
 *
 * The Material contains trade secrets, proprietary information, and confidential information.
 * No part of the Material may be used, copied, reproduced, modified, published, distributed, or
 * disclosed in any way without Frictionless Systems, LLC’s express prior written permission.
 *
 * The Material may be protected under patent, trademark, copyright, or trade secret laws.  No
 * license is granted to you by disclosure or delivery of the Materials.  Any license must be
 * express and approved by Frictionless Systems, LLC in writing.
 *
 * “Frictionless Systems” and “Impulse” are registered trademarks of Frictionless Systems, LLC.
 */

@file:Suppress("ktlint:standard:filename")

package systems.frictionless.impulse.browser.ext

import org.jetbrains.compose.web.attributes.AttrsScope
import org.w3c.dom.Element
import systems.frictionless.impulse.browser.id.HtmlId

fun <TElement : Element> AttrsScope<TElement>.id(htmlId: HtmlId) = id(htmlId.idString)
